import { render } from "./DonationSetup.vue?vue&type=template&id=93e85402&scoped=true"
import script from "./DonationSetup.vue?vue&type=script&lang=js"
export * from "./DonationSetup.vue?vue&type=script&lang=js"

import "./DonationSetup.vue?vue&type=style&index=0&id=93e85402&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93e85402"]])

export default __exports__